import React from "react";
import { makeStyles, createStyles, Theme } from "@material-ui/core/styles";
import Paper from "@material-ui/core/Paper";
import Grid from "@material-ui/core/Grid";
import { Typography } from "@material-ui/core";
import Box from '@mui/material/Box';
import ArrowForwardIcon from "@material-ui/icons/ArrowForward";

interface WhiteCardType {
  image: string;
  heading: string;
  subheading: string | undefined;
  onClickButton: Function;
  color: string;
}

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    paper: {
      height: 200,
      width: 150,
      border: "1px solid transparent",
      borderRadius: "10px",
      textAlign: "right",
    },
    rightArrow: {
      padding: "8px",
    },
    h6: {
      fontSize: "20px",
      fontWeight: "bolder",
    },
    body1: {
      fontSize: "18px",
    },
  })
);

export default function WhiteCard(props: WhiteCardType) {
  const classes = useStyles();

  const onClickButton = () => {
    if (props?.onClickButton) props?.onClickButton();
  };

  return (
    <Grid item xs={6}>
      <Paper
        className={classes.paper}
        style={{ backgroundColor: `${props.color}` }}
        onClick={() => onClickButton()}
        elevation={3}
      >
        <ArrowForwardIcon className={classes.rightArrow} />
        <Box component="div" mt={3} m={4} textAlign="center">
          <Typography variant="h6" component="h2" className={classes.h6}>
            {props?.heading}
          </Typography>
        </Box>
        <Box component="div" mt={3} textAlign="center">
          <Typography variant="body1" className={classes.body1}>
            {props?.subheading}
          </Typography>
        </Box>
      </Paper>
    </Grid>
  );
}
